module.exports = __webpack_public_path__ + "static/img/timer-catch.e8277eba.svg";